import {
  type ChartVariantType,
  type PropertiesConfigInputVisualEffectModel,
} from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class ChartPropsBuilder extends PropsBuilder<Exclude<ChartVariantType, 'chartSingle'>> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { background: { visualEffect } } });
    return this;
  };
}

export class ChartSinglePropsBuilder extends PropsBuilder<'chartSingle'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { background: { visualEffect } } });
    return this;
  };
}
